<template>
  <div class="tkc_editor" :class="{ tkc_editor__disabled: disabled, tkc_editor__warning: warning }">
    <slot></slot>
    <div
      class="tkc_editor_layer"
      :class="active ? 'tkc_editor_layer--active' : null"
      @click="clickLayerHandler"
    >
      <i
        v-for="(btnName, index) in data"
        :key="index"
        class="tkc_editor_item"
        :class="'tkc_editor_' + btnName"
        @click.stop="clickItemHandler(btnName)"
      >
        <svg :class="`cusicon-${btnName}`" aria-hidden="true">
          <use :xlink:href="`#cusicon-${btnName}`" />
        </svg>
      </i>
      <i
        v-for="(btnName, index) in activeData"
        :key="index"
        class="tkc_editor_item"
        :class="['tkc_editor_' + btnName, 'tkc_editor_item--active']"
        @click.stop="clickItemHandler(btnName)"
      >
      </i>
      <slot name="data" class-name="tkc_editor_item"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EditorComponent',
    props: {
      data: {
        type: Array,
        default() {
          return ['close', 'editor', 'checked'];
        },
      },
      activeData: {
        type: Array,
        default() {
          return [];
        },
      },
      disabled: Boolean,
      warning: Boolean,
    },
    computed: {
      list() {
        return this.data.concat(this.activeData);
      },
      active() {
        return this.activeData.length > 0;
      },
    },
    methods: {
      clickItemHandler(btnName) {
        if (!this.disabled) {
          this.$emit(btnName);
        }
      },
      clickLayerHandler(e) {
        if (!this.disabled) {
          this.$emit('click', e);
        }
      },
    },
  };
</script>

<style lang="less">
  @import '../../../themes';
  .tkc_editor {
    position: relative;
    height: 100%;
  }

  .tkc_editor_layer {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid @primary-color;
    left: 0;
    top: 0;
    box-sizing: border-box;
  }

  .tkc_editor_layer--active {
    display: block;
  }

  .tkc_editor__warning .tkc_editor_layer {
    border: 1px solid #ff5414;
  }

  .tkc_editor__disabled .tkc_editor_layer {
    display: none;
  }

  .tkc_editor:hover .tkc_editor_layer {
    display: block;
  }

  .tkc_editor__disabled:hover .tkc_editor_layer {
    display: none;
  }

  .tkc_editor_layer--active .tkc_editor_item {
    display: none;
  }

  .tkc_editor:hover .tkc_editor_item {
    display: flex;
  }

  .tkc_editor_item--active {
    display: none;
  }

  .tkc_editor_close {
    width: 16px;
    height: 16px;
    position: absolute;
    top: -5px;
    right: -7px;
    cursor: pointer;
    background-color: #ff0000;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #fff;

    .cusicon-close {
      width: 12px;
      height: 12px;
      fill: currentColor;
      overflow: hidden;
    }
  }

  .tkc_editor_editor {
    width: 23px;
    height: 23px;
    position: absolute;
    right: 0;
    bottom: 0;
    cursor: pointer;
    background-color: @primary-color;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    .cusicon-editor {
      width: 18px;
      height: 18px;
      fill: currentColor;
      overflow: hidden;
    }
  }

  .tkc_editor_checked {
    width: 23px;
    height: 15px;
    position: absolute;
    display: none;
    right: 0;
    bottom: 0;
    cursor: pointer;
    background-color: @primary-color;
    color: #fff;
    justify-content: center;
    align-items: center;

    .cusicon-checked {
      width: 16px;
      height: 14px;
      fill: currentColor;
      overflow: hidden;
      margin-left: 2px;
    }
  }

  .tkc_photo_list_editor {
    &:hover {
      .tkc_editor_layer {
        .tkc_editor_checked {
          display: none;
        }
      }
    }
  }

  .photo-selected {
    .tkc_photo_list_editor {
      .tkc_editor_layer {
        opacity: 1;
        display: block;
        .tkc_editor_close {
          display: none;
        }
        .tkc_editor_checked {
          display: flex;
        }
        .tkc_editor_editor {
          display: none;
        }
      }

      &:hover {
        .tkc_editor_layer {
          .tkc_editor_editor {
            display: flex;
          }
          .tkc_editor_checked {
            display: none;
          }
          .tkc_editor_close {
            display: flex;
          }
        }
      }
    }
  }
</style>
